/* ==========================================================================
   KOLP — Analytics providers
   Each provider is loaded ONLY after consent (analytics or marketing) and
   subscribes to the single KOLP event bus. No event is sent twice: the
   dispatcher in kolp-core.js already de-dupes by payload signature.

   Configure IDs in Theme settings → Analytics & consent, or in
   snippets/theme-globals.liquid. See docs/ANALYTICS.md.
   ========================================================================== */
(function () {
  'use strict';
  var KOLP = window.KOLP || {};
  var S = KOLP.settings || {};
  var loaded = { ga4: false, meta: false, tiktok: false, gads: false, contentsquare: false };

  function inject(src, attrs) {
    var s = document.createElement('script');
    s.async = true; s.src = src;
    Object.keys(attrs || {}).forEach(function (k) { s.setAttribute(k, attrs[k]); });
    document.head.appendChild(s);
    return s;
  }

  /* ---- GA4 + Google Ads (gtag) ----------------------------------- */
  function initGtag() {
    if (loaded.ga4 || (!S.ga4Id && !S.googleAdsId)) return;
    loaded.ga4 = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    var id = S.ga4Id || S.googleAdsId;
    inject('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id));
    gtag('js', new Date());
    gtag('consent', 'default', { ad_storage: 'granted', analytics_storage: 'granted' });
    if (S.ga4Id) gtag('config', S.ga4Id, { send_page_view: true });
    if (S.googleAdsId) { loaded.gads = true; gtag('config', S.googleAdsId); }
  }

  /* ---- Meta Pixel ---------------------------------------------- */
  function initMeta() {
    if (loaded.meta || !S.metaPixelId) return;
    loaded.meta = true;
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', S.metaPixelId);
    window.fbq('track', 'PageView');
  }

  /* ---- TikTok Pixel ------------------------------------------ */
  function initTikTok() {
    if (loaded.tiktok || !S.tiktokPixelId) return;
    loaded.tiktok = true;
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
      ttq.setAndDefer = function (o, m) { o[m] = function () { o.push([m].concat(Array.prototype.slice.call(arguments, 0))); }; };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (n) { var o = ttq._i[n] || []; for (var j = 0; j < ttq.methods.length; j++) ttq.setAndDefer(o, ttq.methods[j]); return o; };
      ttq.load = function (e, o) {
        var url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = url; ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
        ttq._o = ttq._o || {}; ttq._o[e] = o || {};
        var s = d.createElement('script'); s.type = 'text/javascript'; s.async = !0; s.src = url + '?sdkid=' + e + '&lib=' + t;
        var f = d.getElementsByTagName('script')[0]; f.parentNode.insertBefore(s, f);
      };
      ttq.load(S.tiktokPixelId);
      ttq.page();
    }(window, document, 'ttq');
  }

  /* Contentsquare (formerly Hotjar). Session replay and heatmaps, so it waits
     for ANALYTICS consent — never marketing alone. The tag is a hex id and the
     script self-configures from CS_CONF inside it, so there is nothing to pass.
     Verified against t.contentsquare.net; the old static.hotjar.com host 404s
     for these ids. */
  function initContentsquare() {
    if (loaded.contentsquare || !S.contentsquareTagId) return;
    loaded.contentsquare = true;
    inject('https://t.contentsquare.net/uxa/' + encodeURIComponent(S.contentsquareTagId) + '.js');
  }

  function initAll() {
    initGtag(); initMeta(); initTikTok();
  }

  KOLP.consent.ready(function (c) {
    if (c.analytics || c.marketing) initAll();
    if (c.analytics) initContentsquare();
  });
  KOLP.bus.on('consent:change', function (c) {
    if (c.analytics || c.marketing) initAll();
    if (c.analytics) initContentsquare();
  });

  /* ---- map KOLP events -> provider events ---------------------- */
  var GA4_MAP = {
    view_item: 'view_item', select_item: 'select_item', select_bundle: 'select_promotion',
    select_color: 'select_item', select_size: 'select_item', add_to_cart: 'add_to_cart',
    view_cart: 'view_cart', begin_checkout: 'begin_checkout', purchase: 'purchase',
    newsletter_signup: 'sign_up'
  };
  var META_MAP = {
    view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout',
    purchase: 'Purchase', newsletter_signup: 'Lead', select_bundle: 'CustomizeProduct'
  };
  var TT_MAP = {
    view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout',
    purchase: 'CompletePayment', newsletter_signup: 'SubmitForm'
  };

  KOLP.bus.on('analytics:*', function (msg) {
    var e = msg.event, p = msg.payload || {};
    if (window.gtag && GA4_MAP[e]) {
      window.gtag('event', GA4_MAP[e], p);
    }
    if (window.fbq && META_MAP[e]) {
      window.fbq('track', META_MAP[e], {
        value: p.value || p.bundle_value, currency: p.currency || 'EUR', contents: p.items
      });
    }
    if (window.ttq && TT_MAP[e]) {
      window.ttq.track(TT_MAP[e], { value: p.value || p.bundle_value, currency: p.currency || 'EUR' });
    }
    if (e === 'purchase' && window.gtag && S.googleAdsId && S.googleAdsConversionLabel) {
      window.gtag('event', 'conversion', {
        send_to: S.googleAdsId + '/' + S.googleAdsConversionLabel,
        value: p.value, currency: p.currency || 'EUR', transaction_id: p.transaction_id || ''
      });
    }
  });
})();
